import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { IcMoreIcon } from '@gem/icons';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import { useShowMoreButtonPresenter } from './ShowMoreButton.presenter';
import styles from './ShowMoreButton.styles.m.css';

interface IShowMoreButtonProps {
  className?: string;
}

export const ShowMoreButton: FC<IShowMoreButtonProps> = observer(({ className }) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const presenter = useShowMoreButtonPresenter();

  return (
    <>
      {!!presenter.menu.length && (
        <IconButton
          Icon={IcMoreIcon}
          onClick={presenter.togglePopover}
          size={IconViewSizes.Big}
          theme="12"
          iconSize={IconViewSizes.Medium}
          className={className}
          setRef={buttonRef}
          dataTest="callview-call-additional-actions-panel-kebab-menu-button"
        />
      )}
      <PopoverMenu
        className={styles.popover}
        isOpened={presenter.isPopoverOpened}
        placement="top-end"
        menuItems={presenter.menu}
        reference={buttonRef.current}
        onClose={presenter.closePopover}
        theme={'dark'}
      />
    </>
  );
});
